let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jBg7C")).then(() => parcelRequire('7nySO'));